import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { ApplicationService } from 'src/app/services/application-service';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { IdentificationComponent } from '../identification/identification.component';
import { companyAssociationOptions } from 'src/configs/dropdown-options/options.se';

import { AuthService } from 'src/app/services/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CompanyApiService } from 'src/app/services/api/company-api.service';
import { LoginApiService } from 'src/app/services/api/login-api.service';
import { Subscription } from 'rxjs';
import { TrackingService } from 'src/app/services/tracking.service';
import { FlowService } from 'src/app/services/flow.service';

@Component({
  selector: 'app-company-association',
  templateUrl: './company-association.component.html',
  styleUrls: ['./company-association.component.scss'],
})
export class CompanyAssociationComponent
  extends IdentificationComponent
  implements OnInit, OnDestroy {
  applicationId!: number;
  companyAssociationForm!: FormGroup;
  companyAssociationOptions = companyAssociationOptions;
  error!: string;
  subs = Array<Subscription>();

  constructor(
    public basicInfoService: BasicInfoService,
    public router: Router,
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    public applicationService: ApplicationService,
    // IdentificationComponent
    public companyApi: CompanyApiService,
    public loginApi: LoginApiService,
    public deviceService: DeviceDetectorService,
    public authService: AuthService,
    public trackingService: TrackingService,
    protected flowService: FlowService
  ) {
    super(
      companyApi,
      loginApi,
      basicInfoService,
      deviceService,
      translateService,
      router,
      authService,
      applicationService,
      trackingService,
      flowService
    );
  }

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;
    this.companyAssociationForm = this.formBuilder.group({
      companyAssociation: ['', [Validators.required]],
    });
    this.subs.push(
      this.companyAssociation.valueChanges
        .pipe(debounceTime(1000))
        .subscribe((v) => {
          this.basicInfoService.companyAssociation = v;
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }

  handleButtonClick(): void {
    if (this.caForm.invalid) {
      return;
    }

    this.trackingService.filledField('company-association');

    this.loading = true;
    this.handleIdentification(this.basicInfoService.personNumber);
  }

  get caForm(): FormGroup {
    return this.companyAssociationForm;
  }

  get companyAssociation(): FormControl {
    return this.caForm.get('companyAssociation') as FormControl;
  }

  getCaErrors(control: string): string | null {
    const companyAssociation = this.companyAssociation;
    switch (control) {
      case 'companyAssociation':
        if (companyAssociation.hasError('required')) {
          return this.translateService.instant(
            'global.error.companyAssociationRequired'
          );
        }
        return null;
      default:
        return null;
    }
  }
}
